<template>
    <form-row title="Other Insurance Coverage" :label_align_top="true">
        <div class="flex flex-1 flex-col">
            <div class="flex flex-1 flex-col">
                <div v-for="(insurance, index) in insurances"
                    :key="insurance.id"
                    class="border-b border-gray-400 pb-8 mb-8"
                >
                    <div class="flex mb-4">
                        <input-text
                            class="w-full"
                            :name="'other_insurance_policies[' + index + '][type]'"
                            label="Type"
                            v-model="insurance.type"
                            :read_only="read_only"
                        />
                    </div>

                    <div class="flex mb-4">
                        <input-text
                            class="w-full"
                            :name="'other_insurance_policies[' + index + '][policy_number]'"
                            label="Policy Number"
                            v-model="insurance.policy_number"
                            :read_only="read_only"
                        />
                    </div>

                    <div class="flex mb-4">
                        <input-text
                            class="w-full"
                            :name="'other_insurance_policies[' + index + '][company]'"
                            :value="insurance.company"
                            label="Insurance Company"
                            :read_only="read_only"
                        />
                    </div>

                    <div class="flex flex-col sm:flex-row mb-4">
                        <div class="sm:col-gap-1 flex-1">
                            <input-text
                                :name="'other_insurance_policies[' + index + '][agent_name]'"
                                :value="insurance.agent_name"
                                label="Agent Name"
                                :read_only="read_only"
                            />
                        </div>

                        <div class="mt-4 sm:mt-0 sm:col-gap-1 flex-1">
                            <input-text
                                :name="'other_insurance_policies[' + index + '][agent_email]'"
                                :value="insurance.agent_email"
                                label="Email"
                                placeholder="Email"
                                :read_only="read_only"
                            />
                        </div>

                        <div class="mt-4 sm:mt-0 sm:col-gap-1 flex-1">
                            <input-text
                                :name="'other_insurance_policies[' + index + '][agent_phone]'"
                                :value="insurance.agent_phone"
                                label="Phone"
                                :read_only="read_only"
                            />
                        </div>
                    </div>

                    <div class="flex flex-1 justify-end">
                        <div
                            v-if="! read_only"
                            class="cursor-pointer flex hover:text-red-600 items-center justify-end text-gray-400 w-6"
                            @click="deleteItem(insurance)"
                        >
                            <i class="fas fa-minus-circle"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex items-center justify-end">
                <button v-if="! read_only"
                    type="button"
                    class="flex items-center uppercase text-blue-500 hover:text-blue-600 leading-none focus:shadow-none"
                >
                    <span class="text-xl font-bold mr-2">+</span>

                    <span class="inline-block font-semibold text-sm py-2 cursor-pointer select-none"
                        @click="addItem"
                    >
                        {{ $t('Add insurance coverage') }}
                    </span>
                </button>
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        other_insurance_policies: {},
        read_only: { default: false },
    },

    data() {
        return {
            insurances: this.getInsurances(),
        }
    },

    methods: {
        getInsurances() {
            return this.other_insurance_policies && this.other_insurance_policies.length
                ? this.other_insurance_policies
                : [];
        },
        addItem() {
            this.insurances.push(this.getEmptyInsuranceObject());
        },
        deleteItem(item) {
            const index = this.insurances.findIndex(insurance => insurance.id == item.id);

            if (index > -1) {
                this.insurances.splice(index, 1);
            }
        },
        getRandomKey() {
            return Math.floor(Math.random() * (999999 - 1) + 1);
        },
        getEmptyInsuranceObject() {
            return {
                id: this.getRandomKey(),
                type: null,
                policy_number: null,
                company: null,
                agent_name: null,
                agent_email: null,
                agent_phone: null,
            }
        },
    },
}
</script>
